import getWorkshop from "./getWorkshop";
import {PRICE_TYPE_GROSS, PRICE_TYPE_NET} from "./price";

function displayDependentOnShowPrice(netValue, grossValue, showPrice = null) {
  switch (showPrice ?? getWorkshop().settingShowPrice) {
    case PRICE_TYPE_NET: return netValue;
    case PRICE_TYPE_GROSS: return grossValue;
    default: return null;
  }
}

export default displayDependentOnShowPrice;